import PrintOut from './printout.container'

export default PrintOut
